import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'environments/environment';
import { UserBService } from 'app/modules/ok-admin/misc/user-b.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { UserB } from 'app/modules/ok-admin/misc/user-b';
import { ChatService } from 'app/modules/chat/chat.service';

@Injectable({ providedIn: 'root' })
export class GlobalChatWsService implements OnDestroy {
    private ws?: WebSocket;
    private user?: UserB;
    
    API_BASE_URL = environment.baseUrl || 'https://api.staging.tchauusado.com.br';
    WS_URL = this.API_BASE_URL.replace(/^http/, 'ws');

    constructor(
        private userService: UserBService,
        private notificationsService: NotificationsService,
        private chatService: ChatService
    ) {}

    init() {
        this.userService.user$.subscribe((user) => {
            this.user = user;
        });
        
        this.connect();
    }

    connect() {
        this.ws = new WebSocket(`${this.WS_URL}/ws/conversations`);
        this.ws.onmessage = (e) => {
            const data = JSON.parse(e.data);
            if (data.type !== 'conversation_update') return;

            const isHandoffAlert = data.lastMessage?.senderId == null && data.lastMessage?.content?.includes("Vou transferir o seu chat para um de nossos especialistas");
            
            if (isHandoffAlert && !data.lastMessage?.read) {
                this.playBeep();
                this.createNotification(data, 'Handoff de Atendimento!', 'Cliente quer falar com humano.');
                return;
            }

            const isFromCustomer = data.lastMessage?.senderId != null && data.lastMessage?.senderId !== this.user?.id;
            
            if (isFromCustomer && !data.lastMessage?.read) {
                // we need to know if botActive === false. Fetch the conversation to be sure.
                this.chatService.getConversation(data.conversationId).subscribe((resp: any) => {
                    const conv = resp.conversation;
                    if (conv && conv.botActive === false) {
                        this.playBeep();
                        this.createNotification(data, 'Nova mensagem de Atendimento', data.lastMessage.content?.substring(0, 50) || 'Imagem recebida...');
                    }
                });
            }
        };
        
        this.ws.onclose = () => {
            setTimeout(() => this.connect(), 5000);
        };
    }
    
    createNotification(data: any, title: string, description: string) {
        this.notificationsService.create({
            id: Math.random().toString(),
            title,
            description,
            time: new Date().toISOString(),
            read: false,
            link: '/chat?conversationId=' + data.conversationId,
            useRouter: true
        } as any).subscribe();
    }

    playBeep(): void {
        try {
            const AudioContext = window.AudioContext || (window as any).webkitAudioContext;
            if (!AudioContext) return;
            const ctx = new AudioContext();
            const osc = ctx.createOscillator();
            const gainNode = ctx.createGain();
            
            osc.type = 'sine';
            osc.frequency.setValueAtTime(800, ctx.currentTime);
            
            gainNode.gain.setValueAtTime(0.1, ctx.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.15);
            
            osc.connect(gainNode);
            gainNode.connect(ctx.destination);
            
            osc.start();
            osc.stop(ctx.currentTime + 0.15);
        } catch (e) {
            console.log('Erro ao tocar som:', e);
        }
    }

    ngOnDestroy() {
        this.ws?.close();
    }
}
